import { render, staticRenderFns } from "./clientRefund.vue?vue&type=template&id=55d6b2ca&scoped=true&"
import script from "./clientRefund.vue?vue&type=script&lang=js&"
export * from "./clientRefund.vue?vue&type=script&lang=js&"
import style0 from "./clientRefund.vue?vue&type=style&index=0&id=55d6b2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6b2ca",
  null
  
)

export default component.exports